import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { teacherRetrieveStudent, resetTeacherStudentRetrieval } from "./retrieve-student";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { TeacherStudentDetails } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<Nullable<TeacherStudentDetails>> = { fetching: "idle", data: null };

export const teacherRetrieveStudentReducer = createReducer<RetrievalState<Nullable<TeacherStudentDetails>>>(initialState, builder => {
  builder.addCase(teacherRetrieveStudent.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(teacherRetrieveStudent.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(teacherRetrieveStudent.rejected, (state, { payload }) => {
    if (payload?.status === 404) {
      return {
        ...state,
        data: null,
        fetching: "success",
      };
    }

    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetTeacherStudentRetrieval, () => {
    return initialState;
  });
});
